export interface FederacionJSON {
  fed_id: string | null;
  fed_denominacion: string;
  fed_sigla: string;
  fed_logo: string;
  fed_contacto_apellido: string;
  fed_contacto_nombre: string;
  fed_telefono: string;
  fed_activa: boolean;
  fed_email: string;
  fed_gestion_seguro: string;
}

export class Federacion {
  protected constructor(
    private id: string | null,
    private denominacion: string,
    private sigla: string,
    private logo: string,
    private contactoApellido: string,
    private contactoNombre: string,
    private telefono: string,
    private activa: boolean,
    private email: string,
    private gestionSeguro: string
  ) {}

  static createFrom(
    id: string | null,
    denominacion: string,
    sigla: string,
    logo: string,
    contactoApellido: string,
    contactoNombre: string,
    telefono: string,
    activa: boolean,
    email: string,
    gestionSeguro: string
  ) {
    return new this(
      id,
      denominacion,
      sigla,
      logo,
      contactoApellido,
      contactoNombre,
      telefono,
      activa,
      email,
      gestionSeguro
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Federacion) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }
  static fromJSON(entity: FederacionJSON) {
    return Federacion.createFrom(
      entity.fed_id,
      entity.fed_denominacion,
      entity.fed_sigla,
      entity.fed_logo,
      entity.fed_contacto_apellido,
      entity.fed_contacto_nombre,
      entity.fed_telefono,
      entity.fed_activa,
      entity.fed_email,
      entity.fed_gestion_seguro
    );
  }

  toJSON(): FederacionJSON {
    return {
      fed_id: this.getId(),
      fed_denominacion: this.getDenominacion(),
      fed_sigla: this.getSigla(),
      fed_logo: this.getLogo(),
      fed_contacto_apellido: this.getContactoApellido(),
      fed_contacto_nombre: this.getContactoNombre(),
      fed_telefono: this.getTelefono(),
      fed_activa: this.getActiva(),
      fed_email: this.getEmail(),
      fed_gestion_seguro: this.getGestionSeguro(),
    };
  }

  fullname(){
    return `${this.denominacion} (${this.sigla})`
  }

  getId(): string | null {
    return this.id;
  }

  getDenominacion(): string {
    return this.denominacion;
  }

  getSigla(): string {
    return this.sigla;
  }

  getLogo(): string {
    return this.logo;
  }

  getContactoApellido(): string {
    return this.contactoApellido;
  }

  getContactoNombre(): string {
    return this.contactoNombre;
  }

  getTelefono(): string {
    return this.telefono;
  }

  getActiva(): any {
    return this.activa;
  }

  getEmail(): string {
    return this.email;
  }

  getGestionSeguro(): string {
    return this.gestionSeguro;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDenominacion(value: string): void {
    this.denominacion = value;
  }

  setSigla(value: string): void {
    this.sigla = value;
  }

  setLogo(value: string): void {
    this.logo = value;
  }

  setContactoApellido(value: string): void {
    this.contactoApellido = value;
  }

  setContactoNombre(value: string): void {
    this.contactoNombre = value;
  }

  setTelefono(value: string): void {
    this.telefono = value;
  }

  setActiva(value: any): void {
    this.activa = value;
  }

  setEmail(value: string): void {
    this.email = value;
  }
}
